import React, { useContext } from 'react';
import { FontIcon } from 'react-md';
import moment from 'moment';
import styled from 'styled-components';

import { default as Store } from '../../../../services/api/store';
import useSocietySettings from '../../../Society/hooks/useSocietySettings';
import StartEndTime from '../../../../components/General/StartEndTime';
import * as palette from '../../../../components/General/Variables';
import AuthButton from '../../../User/containers/AuthButton';
import { TimezoneContext } from '../../../Timezone/context';

const Wrapper = styled.div`
    align-items: center;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.2);
    background-color: #ffffff;
    display: flex;
    flex-flow: row;
    height: 56px;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    padding: 0 16px 0 0 !important;
    z-index: 4;
    ${props => !props.nozindex && 'z-index: 16;'}
`;

const Icon = styled(FontIcon)`
    vertical-align: top;
    color: rgba(0, 0, 0, 0.87) !important;
    margin-left: 20px;
    font-size: 20px;
    cursor: pointer;
`;

const TextWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;
`;

const SessionInfo = styled.div`
    display: flex;
    flex-direction: column;
    flex: 3;
    overflow: hidden;
    margin-left: 20px;
    height: 100%;

    @media only screen and (max-width: ${palette.MAX_PHONE}) {
        margin-left: 12px;
    }
`;

const SessionName = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: 'Cabin', sans-serif;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: rgba(0, 0, 0, 0.87);
    margin-left: 12px;
    font-weight: 700;
    font-size: 15px;
    line-height: 20px;
`;

const Header = ({ goBack, timeslot, newVersionAvailable, updateServiceWorker, noZIndex }) => {
    const { isSociety } = useSocietySettings();
    let timeslotWithTimezone;
    let timezone;

    const timezoneContext = useContext(TimezoneContext);
    if (!isSociety) {
        const { timeslotToTimezone } = timezoneContext;

        timeslotWithTimezone = timeslotToTimezone(timeslot);
        timezone = Store.argument.offsetTimezone;
    } else {
        timeslotWithTimezone = timeslot;
    }

    const isAppointment = timeslot.type === 'appointment';

    let start = moment.utc(timeslotWithTimezone.start);
    if (!start.isValid()) {
        start = moment.unix(timeslotWithTimezone.start);
    }
    if (isAppointment || isSociety) {
        start = start.utc();
    } else {
        start = start.utcOffset(timezone, true);
    }
    let end = moment.utc(timeslotWithTimezone.end);
    if (!end.isValid()) {
        end = moment.unix(timeslotWithTimezone.end);
    }
    if (isAppointment || isSociety) {
        end = end.utc();
    } else {
        end = end.utcOffset(timezone, true);
    }
    const startTime = moment(start).format('HH:mm');
    const endTime = moment(end).format('HH:mm');

    return (
        <Wrapper nozindex={noZIndex ? 1 : 0}>
            <Icon onClick={goBack}>{palette.ICON_BACK}</Icon>
            <SessionInfo desktopSize={9}>
                <TextWrapper>
                    {timeslot?.start && (
                        <StartEndTime text={`${startTime} - ${endTime}`} isVirtual />
                    )}
                    <SessionName>{timeslot.name}</SessionName>
                </TextWrapper>
            </SessionInfo>
            <AuthButton
                light
                newVersionAvailable={newVersionAvailable}
                updateServiceWorker={updateServiceWorker}
            />
        </Wrapper>
    );
};

export default Header;
